import React, { useEffect, useState, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import discussionIcon from "src/assets/images/discuss-icon.png";
import messageIcon from "src/assets/images/message-icon.png";
import notificationIcon from "src/assets/images/notification-icon.png";
import productTestIcon from "src/assets/images/products-tets-icon.png";
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import { convertToKebabCase } from 'src/helpers/helperFunctions';
interface IHeaderList {
    title: string;
    icon: string;
    url: string;
    isDisplay: boolean;
};

const HeaderNav: React.FC = () => {
    const { pathname } = useLocation();
    const { messageUnreadCount, unreadNotificationCount } = useSelector((store: RootState) => store.appReducer);
    const headerList: IHeaderList[] = [
        // {
        //     title: "Discussions",
        //     icon: discussionIcon,
        //     url: "/discussions",
        //     isDisplay: true,
        // },
        // {
        //     title: "Messaging",
        //     icon: messageIcon,
        //     url: "/message",
        //     isDisplay: true,
        // },
        {
            title: "Notifications",
            icon: notificationIcon,
            url: "/notifications",
            isDisplay: true,
        },
    ];
    const [showBuy, setShowBuy] = useState(false);
    const buyRef = useRef<HTMLDivElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (buyRef.current && !buyRef.current.contains(event.target as Node)) {
            setShowBuy(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        setShowBuy(false);
    }, [pathname]);
    return (
        <>
            {/* <div className="buy-section" ref={buyRef}>
                <div className="buy-hover-trigger">
                    <NavLink
                        onClick={() => setShowBuy(!showBuy)}
                        to=""
                        className={`header-nav-items header-nav-items-buys ${pathname === '/customer/homecareservices' ||
                            pathname === '/customer/pharmacy-products' ||
                            pathname === '/customer/diagnostic-products'
                            ? 'header-nav-items-active'
                            : ''
                            }`}
                    >
                        <div className="relative">
                            <img src={productTestIcon} alt="" width={20} height={20} />
                        </div>
                        <p className="font-size-14px header-nav-items-buy-para font-Poppins-Medium">
                            Buy<span>{showBuy ? '\u2BC5' : '\u2BC6'}</span>
                        </p>
                    </NavLink>
                    {showBuy && (
                        <div className="buy-poppup-main">
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                to={'/customer/diagnostic-products'}
                                className={`buy-poppup ${pathname === '/customer/diagnostic-products' ? 'buy-poppup-active' : ''
                                    }`}
                            >
                                <img src={productTestIcon} alt="" />
                                <p className="font-size-13px text-white font-Poppins-Medium">
                                    Lab Tests
                                </p>
                            </NavLink>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                to={'/customer/pharmacy-products'}
                                className={`buy-poppup ${pathname === '/customer/pharmacy-products' ? 'buy-poppup-active' : ''
                                    }`}
                            >
                                <img src={productTestIcon} alt="" />
                                <p className="font-size-13px text-white font-Poppins-Medium">Pharmacy</p>
                            </NavLink>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                to={'/customer/homecareservices'}
                                className={`buy-poppup ${pathname === '/customer/homecareservices' ? 'buy-poppup-active' : ''
                                    }`}
                            >
                                <img src={productTestIcon} alt="" />
                                <p className="font-size-13px text-white font-Poppins-Medium">At-Home Services</p>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div> */}
            <ul className='header-nav'>
                {headerList.filter(v => v.isDisplay).map((item: IHeaderList, index: number) => (
                    <li key={index}>
                        <NavLink to={item.url} id={`header-nav-items-${convertToKebabCase(item.title)}`} className={`header-nav-items ${pathname === item.url ? "header-nav-items-active" : ""}`} style={{ cursor: 'pointer' }}>
                            <div className='relative'>
                                <img src={item.icon} alt="" width={20} height={20} />
                                {(item.title === "Notifications" && unreadNotificationCount)
                                    ?
                                    <span className='cart-count-total font-size-11px text-white font-Poppins-Medium'>{unreadNotificationCount}</span>
                                    : (item.title === "Messaging" && messageUnreadCount)
                                        ?
                                        <span className='cart-count-total font-size-11px text-white font-Poppins-Medium'>{messageUnreadCount}</span>
                                        : ""
                                }
                            </div>
                            <p className='font-size-14px font-Poppins-Medium'>{item.title}</p>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default HeaderNav;